import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [IconButtonComponent],
  imports: [CommonModule, A11yModule],
  exports: [IconButtonComponent],
})
export class IconButtonModule {}
